/**
 * Normaliza la respuesta de GET /dashboard (materializado).
 * ventasHoy = monto del día; cantidadVentasHoy = cantidad de operaciones.
 */
export function normalizarDatosDashboard(dashboardData) {
  if (!dashboardData || typeof dashboardData !== 'object') {
    throw new Error('Respuesta inválida del servidor');
  }

  const cantidadVentasHoy = parseInt(
    dashboardData.cantidadVentasHoy ?? dashboardData.ventasHoy ?? 0,
    10
  );
  const ventasHoy = parseFloat(
    dashboardData.totalVentasHoy ?? dashboardData.ventasHoyMonto ?? 0
  );

  return {
    ventasHoy: Number.isFinite(ventasHoy) ? ventasHoy : 0,
    cantidadVentasHoy: Number.isFinite(cantidadVentasHoy) ? cantidadVentasHoy : 0,
    gananciasHoy: parseFloat(dashboardData.gananciasHoy ?? 0) || 0,
    productosDestacados: Array.isArray(dashboardData.productosDestacados)
      ? dashboardData.productosDestacados
      : [],
    clientesDestacados: Array.isArray(dashboardData.clientesDestacados)
      ? dashboardData.clientesDestacados
      : [],
    totalProductos: parseInt(dashboardData.totalProductos ?? 0, 10) || 0,
    stockBajo: parseInt(dashboardData.productosStockBajo ?? dashboardData.stockBajo ?? 0, 10) || 0,
    totalClientes: parseInt(dashboardData.totalClientes ?? 0, 10) || 0,
    ticketPromedio: parseFloat(dashboardData.ticketPromedio ?? 0) || 0
  };
}

export function rangoMesActual(fechaRef = new Date()) {
  const inicio = new Date(fechaRef.getFullYear(), fechaRef.getMonth(), 1);
  const fin = new Date(fechaRef.getFullYear(), fechaRef.getMonth() + 1, 0);
  const fmt = (d) => d.toISOString().slice(0, 10);
  return { inicio: fmt(inicio), fin: fmt(fin) };
}
